export const isUnusedDaysFromPreviousYearFieldDisabled = (vacationTypeFieldValue) =>{
    if(vacationTypeFieldValue && vacationTypeFieldValue === "/api/vacation_types/2")return false    
    return true
}